import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Information } from "@faire/web--source/slate/icons/foundation/Information";
import { Tooltip as SlateTooltip } from "@faire/web--source/slate/Tooltip";
import { PortalTooltip } from "@faire/web--source/slate/Tooltip/PortalTooltip";
import React from "react";
export var Tooltip = function(param) {
    var target = param.target, children = param.children;
    return /*#__PURE__*/ _jsx(PortalTooltip, {
        tooltipMainAxisOffset: -4,
        tooltipCrossAxisOffset: -4,
        tooltipZIndex: 10000,
        placement: "top",
        tooltip: /*#__PURE__*/ _jsx(SlateTooltip, {
            targetNode: /*#__PURE__*/ _jsx(_Fragment, {}),
            isOpen: true,
            children: children
        }),
        children: target !== null && target !== void 0 ? target : /*#__PURE__*/ _jsx(Information, {
            fontSize: "16px"
        })
    });
};
